import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@zillow/constellation';

import ConnectedNetworkView from 'app/shared/components/ConnectedNetworkView';
import PropertyConstants from 'app/shared/constants/PropertyConstants';

import { StyledText } from 'app/shared/components/ConnectedListingFooter/StyledComponents';
import {
    StyledFlexPriceOnlyContainer,
    StyledPriceTag,
    StyledMobileOnlyVerticalDivider,
    StyledVerticalDivider,
    StyledWeek,
} from './StyledComponents';

const { SYNDICATION_OVERVIEW_STATUS, PROPERTY_TYPES: { COMMUNITY } } = PropertyConstants;

const propTypes = {
    isFree: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    hidePrice: PropTypes.bool,
    lengthOfTime: PropTypes.string,
    price: PropTypes.string,
    propertyType: PropTypes.string.isRequired,
    syndication: PropTypes.object.isRequired,
};

const defaultProps = {
    lengthOfTime: 'week',
    hidePrice: false,
    price: '',
};

const AdditionalInformation = ({
    isFree,
    isMobile,
    hidePrice,
    isScreenTablet,
    lengthOfTime,
    price,
    propertyType,
    syndication,
}) => {
    const { overview: { status } } = syndication;

    const renderPriceComponent = () => {
        if (!price || isFree || hidePrice) {
            return null;
        }
        return (
            <StyledFlexPriceOnlyContainer>
                <Flex display="flex">
                    <StyledPriceTag>{price}</StyledPriceTag>
                    &nbsp;
                    <StyledWeek as="span">
                        {`/${lengthOfTime}`}
                    </StyledWeek>
                </Flex>
                <StyledMobileOnlyVerticalDivider />
            </StyledFlexPriceOnlyContainer>
        );
    };

    if (status === SYNDICATION_OVERVIEW_STATUS.DECLINED) {
        return null;
    }

    if ((status === SYNDICATION_OVERVIEW_STATUS.PUBLISHED && !isMobile)) {
        return renderPriceComponent();
    }

    if ((status === SYNDICATION_OVERVIEW_STATUS.PUBLISHING && !isMobile)) {
        return renderPriceComponent();
    }

    if (status === SYNDICATION_OVERVIEW_STATUS.PARTIALLY_PUBLISHED) {
        return (
            <Flex display="flex" alignItems="center" flexGrow={1}>
                <StyledVerticalDivider />
                <ConnectedNetworkView
                    syndication={syndication}
                    label={`View published ${isMobile ? '' : 'listings'}`}
                />
                {!isMobile && !isScreenTablet && renderPriceComponent()}
            </Flex>
        );
    }

    if (status === SYNDICATION_OVERVIEW_STATUS.INACTIVE) {
        if (isFree && propertyType !== COMMUNITY) {
            return (
                <StyledFlexPriceOnlyContainer>
                    <Flex display="flex">
                        <StyledText>Free to list!</StyledText>
                    </Flex>
                    <StyledMobileOnlyVerticalDivider />
                </StyledFlexPriceOnlyContainer>
            );
        }
        return renderPriceComponent();
    }

    return null;
};

AdditionalInformation.propTypes = propTypes;
AdditionalInformation.defaultProps = defaultProps;

export default AdditionalInformation;
